var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgA = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FC9CB8",
  d: "M15.785 10.094c.9 0 1.564.68 1.564 1.58s-.663 1.58-1.564 1.58c-.916 0-1.58-.68-1.58-1.58s.664-1.58 1.58-1.58M10.415 13.126l-.9-2.496H4.522l-.9 2.496H.652L5.643.25H8.63l4.993 12.876zM5.407 8.134H8.63L7.018 3.647z"
})));
export default SvgA;